// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pages-Bookings-styles___loaderWrapper--aT8k1 {
  position: relative;
}

  .pages-Bookings-styles___loaderWrapper--aT8k1 .pages-Bookings-styles___container--lzQnO {
    display: flex;
  }

  .pages-Bookings-styles___loaderWrapper--aT8k1 .pages-Bookings-styles___container--lzQnO .pages-Bookings-styles___content--I4SCD {
      flex: 1;
      margin-right: 30px;
    }

  .pages-Bookings-styles___loaderWrapper--aT8k1 .pages-Bookings-styles___container--lzQnO .pages-Bookings-styles___sidebar--NF_O1 {
      flex: 352px 0 1;
      min-width: 300px;
    }

.pages-Bookings-styles___userName--lkAz1 {
  text-align: left;
}

.pages-Bookings-styles___header--RqHsn {
  display: flex;
  max-width: 736px;
  align-items: center;
  margin: auto;
  margin-bottom: 32px;
  justify-content: space-between;
}

.pages-Bookings-styles___header--RqHsn h1 {
    flex: 1;
  }

.pages-Bookings-styles___header--RqHsn .pages-Bookings-styles___button--oOhwX {
    height: 34px;
    font-size: 13px;
    padding: 0 16px;
    margin-top: 20px;
  }

.pages-Bookings-styles___header--RqHsn .pages-Bookings-styles___name--Oh4L3 {
    margin-bottom: 8px !important;
  }

.pages-Bookings-styles___header--RqHsn .pages-Bookings-styles___companyName--kQEXW {
    text-align: left;
    font-size: 17px;
    color: #1b2432;
    letter-spacing: 0;
  }

.pages-Bookings-styles___breadcrumbs--rIU4y {
  max-width: 1200px;
  margin: auto;
}

.pages-Bookings-styles___headerPnr--bLuvC {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.pages-Bookings-styles___headerPnr--bLuvC .pages-Bookings-styles___id--lSnVf {
    text-align: left;
    font-size: 40px;
    color: #1b2432;
    letter-spacing: 0;
    margin: 24px 0;
    display: flex;
    font-weight: 300;
  }

.pages-Bookings-styles___headerPnr--bLuvC .pages-Bookings-styles___id--lSnVf .pages-Bookings-styles___buttonCompleted--pq8yG {
      background: #00a69c;
      border-radius: 4px;
      font-size: 13px;
      color: #ffffff;
      letter-spacing: 0;
      min-height: 32px;
      min-width: 80px;
      text-align: center;
      align-self: center;
      margin-left: 40px;
      padding: 8px 8px 0px 8px;
      font-weight: 500;
    }

.pages-Bookings-styles___headerPnr--bLuvC .pages-Bookings-styles___id--lSnVf .pages-Bookings-styles___fraud--vSxnE {
      background: #00a69c;
      border-radius: 4px;
      font-size: 13px;
      color: #ffffff;
      letter-spacing: 0;
      min-height: 32px;
      min-width: 80px;
      text-align: center;
      align-self: center;
      margin-left: 20px;
      padding-top: 8px;
      font-weight: 500;
    }

.pages-Bookings-styles___headerPnr--bLuvC .pages-Bookings-styles___id--lSnVf .pages-Bookings-styles___canceled--sPCxL {
      background: #fc3b60;
    }

.pages-Bookings-styles___headerPnr--bLuvC .pages-Bookings-styles___id--lSnVf .pages-Bookings-styles___pending--h8Xuv {
      background: #6d717a;
    }

.pages-Bookings-styles___headerPnr--bLuvC .pages-Bookings-styles___buttonContainer--zmKno {
    display: flex;
    flex-direction: row;
  }

.pages-Bookings-styles___headerPnr--bLuvC .pages-Bookings-styles___buttonContainer--zmKno div {
      margin-left: 15px;
    }

.pages-Bookings-styles___headerPnr--bLuvC .pages-Bookings-styles___buttonContainer--zmKno button {
      margin-left: 15px;
    }

.pages-Bookings-styles___headerPnr--bLuvC .pages-Bookings-styles___sendEmailButton--aVABD {
    text-align: left;
    min-height: 53px;
    width: 131px;
    border-radius: 6px;
    color: #4f84fa;
    text-align: center;
    align-self: center;
    border: 1px solid #3189fb;
    padding-top: 17px;
    font-size: 17px;
  }

.pages-Bookings-styles___headerPnr--bLuvC .pages-Bookings-styles___sendEmailButton--aVABD:hover {
      cursor: pointer;
    }

.pages-Bookings-styles___headerPnr--bLuvC .pages-Bookings-styles___sendEmailButton--aVABD:disabled {
      border-color: currentColor;
      color: #6d717a;
      cursor: default;
    }

.pages-Bookings-styles___headerPnr--bLuvC .pages-Bookings-styles___crcRedeemButton--Z1igh {
    background-color: #255be4;
    color: #ffffff;
    border: none;
  }

.pages-Bookings-styles___headerPnr--bLuvC .pages-Bookings-styles___crcRedeemButton--Z1igh:hover {
      background-color: #1a4abf;
    }

.pages-Bookings-styles___headerPnr--bLuvC .pages-Bookings-styles___crcRedeemButton--Z1igh:disabled {
      background-color: #92adf1;
      color: #ffffff;
    }

.pages-Bookings-styles___headerPnr--bLuvC .pages-Bookings-styles___cancelButton--CGOQg {
    text-align: left;
    min-height: 53px;
    width: 131px;
    border-radius: 6px;
    text-align: center;
    align-self: center;
    border: 1px solid #fc3b60;
    padding-top: 17px;
    color: #fc3b60 !important;
    margin-left: 10px;
    font-size: 17px;
  }

.pages-Bookings-styles___headerPnr--bLuvC .pages-Bookings-styles___cancelButton--CGOQg:hover {
      cursor: pointer;
    }

.pages-Bookings-styles___headerPnr--bLuvC .pages-Bookings-styles___refundButton--JNRdj {
    min-height: 53px;
    width: 164px;
    margin-left: 6px;
  }

.pages-Bookings-styles___loaderContainer--kfE9v {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.2);
}

.pages-Bookings-styles___tabs--EgzEb,
.pages-Bookings-styles___tab--o0s23 {
  text-transform: initial !important;
}

.pages-Bookings-styles___tabs--EgzEb {
  border-bottom: 1px solid #c6c8cc;
  margin-bottom: 25px;
}

.pages-Bookings-styles___confirmationBodyTextStyle--LZbic {
  width: 450px;
}

.pages-Bookings-styles___bolder--tAf4R {
  font-weight: 600;
}

.pages-Bookings-styles___loaderContainer--kfE9v {
  position: fixed;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
}

.pages-Bookings-styles___boldText--jKrHz {
  font-size: 15px;
  color: #6d717a;
  letter-spacing: 0;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./pages/Bookings/styles.pcss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AAepB;;EAbE;IACE,aAAa;EAWf;;EATE;MACE,OAAO;MACP,kBAAkB;IACpB;;EAEA;MACE,eAAe;MACf,gBAAgB;IAClB;;AAIJ;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;AAuBhC;;AArBE;IACE,OAAO;EACT;;AAEA;IACE,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;AAEA;IACE,6BAA6B;EAC/B;;AAEA;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;AAGF;EACE,iBAAiB;EACjB,YAAY;AACd;;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAoHhC;;AAlHE;IACE,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,gBAAgB;EAsClB;;AApCE;MACE,mBAAmB;MACnB,kBAAkB;MAClB,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,kBAAkB;MAClB,kBAAkB;MAClB,iBAAiB;MACjB,wBAAwB;MACxB,gBAAgB;IAClB;;AAEA;MACE,mBAAmB;MACnB,kBAAkB;MAClB,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,kBAAkB;MAClB,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;MAChB,gBAAgB;IAClB;;AAEA;MACE,mBAAmB;IACrB;;AACA;MACE,mBAAmB;IACrB;;AAGF;IACE,aAAa;IACb,mBAAmB;EAOrB;;AANE;MACE,iBAAiB;IACnB;;AACA;MACE,iBAAiB;IACnB;;AAGF;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;EASjB;;AARE;MACE,eAAe;IACjB;;AACA;MACE,0BAA0B;MAC1B,cAAc;MACd,eAAe;IACjB;;AAGF;IACE,yBAAyB;IACzB,cAAc;IACd,YAAY;EAQd;;AAPE;MACE,yBAAyB;IAC3B;;AACA;MACE,yBAAyB;MACzB,cAAc;IAChB;;AAGF;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;EAIjB;;AAHE;MACE,eAAe;IACjB;;AAGF;IACE,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;EAClB;;AAGF;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".loaderWrapper {\n  position: relative;\n\n  .container {\n    display: flex;\n\n    .content {\n      flex: 1;\n      margin-right: 30px;\n    }\n\n    .sidebar {\n      flex: 352px 0 1;\n      min-width: 300px;\n    }\n  }\n}\n\n.userName {\n  text-align: left;\n}\n\n.header {\n  display: flex;\n  max-width: 736px;\n  align-items: center;\n  margin: auto;\n  margin-bottom: 32px;\n  justify-content: space-between;\n\n  h1 {\n    flex: 1;\n  }\n\n  .button {\n    height: 34px;\n    font-size: 13px;\n    padding: 0 16px;\n    margin-top: 20px;\n  }\n\n  .name {\n    margin-bottom: 8px !important;\n  }\n\n  .companyName {\n    text-align: left;\n    font-size: 17px;\n    color: #1b2432;\n    letter-spacing: 0;\n  }\n}\n\n.breadcrumbs {\n  max-width: 1200px;\n  margin: auto;\n}\n.headerPnr {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n\n  .id {\n    text-align: left;\n    font-size: 40px;\n    color: #1b2432;\n    letter-spacing: 0;\n    margin: 24px 0;\n    display: flex;\n    font-weight: 300;\n\n    .buttonCompleted {\n      background: #00a69c;\n      border-radius: 4px;\n      font-size: 13px;\n      color: #ffffff;\n      letter-spacing: 0;\n      min-height: 32px;\n      min-width: 80px;\n      text-align: center;\n      align-self: center;\n      margin-left: 40px;\n      padding: 8px 8px 0px 8px;\n      font-weight: 500;\n    }\n\n    .fraud {\n      background: #00a69c;\n      border-radius: 4px;\n      font-size: 13px;\n      color: #ffffff;\n      letter-spacing: 0;\n      min-height: 32px;\n      min-width: 80px;\n      text-align: center;\n      align-self: center;\n      margin-left: 20px;\n      padding-top: 8px;\n      font-weight: 500;\n    }\n\n    .canceled {\n      background: #fc3b60;\n    }\n    .pending {\n      background: #6d717a;\n    }\n  }\n\n  .buttonContainer {\n    display: flex;\n    flex-direction: row;\n    div {\n      margin-left: 15px;\n    }\n    button {\n      margin-left: 15px;\n    }\n  }\n\n  .sendEmailButton {\n    text-align: left;\n    min-height: 53px;\n    width: 131px;\n    border-radius: 6px;\n    color: #4f84fa;\n    text-align: center;\n    align-self: center;\n    border: 1px solid #3189fb;\n    padding-top: 17px;\n    font-size: 17px;\n    &:hover {\n      cursor: pointer;\n    }\n    &:disabled {\n      border-color: currentColor;\n      color: #6d717a;\n      cursor: default;\n    }\n  }\n\n  .crcRedeemButton {\n    background-color: #255be4;\n    color: #ffffff;\n    border: none;\n    &:hover {\n      background-color: #1a4abf;\n    }\n    &:disabled {\n      background-color: #92adf1;\n      color: #ffffff;\n    }\n  }\n\n  .cancelButton {\n    text-align: left;\n    min-height: 53px;\n    width: 131px;\n    border-radius: 6px;\n    text-align: center;\n    align-self: center;\n    border: 1px solid #fc3b60;\n    padding-top: 17px;\n    color: #fc3b60 !important;\n    margin-left: 10px;\n    font-size: 17px;\n    &:hover {\n      cursor: pointer;\n    }\n  }\n\n  .refundButton {\n    min-height: 53px;\n    width: 164px;\n    margin-left: 6px;\n  }\n}\n\n.loaderContainer {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.2);\n}\n\n.tabs,\n.tab {\n  text-transform: initial !important;\n}\n\n.tabs {\n  border-bottom: 1px solid #c6c8cc;\n  margin-bottom: 25px;\n}\n\n.confirmationBodyTextStyle {\n  width: 450px;\n}\n\n.bolder {\n  font-weight: 600;\n}\n\n.loaderContainer {\n  position: fixed;\n  left: 0px;\n  top: 0px;\n  width: 100%;\n  height: 100%;\n}\n\n.boldText {\n  font-size: 15px;\n  color: #6d717a;\n  letter-spacing: 0;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loaderWrapper": `pages-Bookings-styles___loaderWrapper--aT8k1`,
	"container": `pages-Bookings-styles___container--lzQnO`,
	"content": `pages-Bookings-styles___content--I4SCD`,
	"sidebar": `pages-Bookings-styles___sidebar--NF_O1`,
	"userName": `pages-Bookings-styles___userName--lkAz1`,
	"header": `pages-Bookings-styles___header--RqHsn`,
	"button": `pages-Bookings-styles___button--oOhwX`,
	"name": `pages-Bookings-styles___name--Oh4L3`,
	"companyName": `pages-Bookings-styles___companyName--kQEXW`,
	"breadcrumbs": `pages-Bookings-styles___breadcrumbs--rIU4y`,
	"headerPnr": `pages-Bookings-styles___headerPnr--bLuvC`,
	"id": `pages-Bookings-styles___id--lSnVf`,
	"buttonCompleted": `pages-Bookings-styles___buttonCompleted--pq8yG`,
	"fraud": `pages-Bookings-styles___fraud--vSxnE`,
	"canceled": `pages-Bookings-styles___canceled--sPCxL`,
	"pending": `pages-Bookings-styles___pending--h8Xuv`,
	"buttonContainer": `pages-Bookings-styles___buttonContainer--zmKno`,
	"sendEmailButton": `pages-Bookings-styles___sendEmailButton--aVABD`,
	"crcRedeemButton": `pages-Bookings-styles___crcRedeemButton--Z1igh`,
	"cancelButton": `pages-Bookings-styles___cancelButton--CGOQg`,
	"refundButton": `pages-Bookings-styles___refundButton--JNRdj`,
	"loaderContainer": `pages-Bookings-styles___loaderContainer--kfE9v`,
	"tabs": `pages-Bookings-styles___tabs--EgzEb`,
	"tab": `pages-Bookings-styles___tab--o0s23`,
	"confirmationBodyTextStyle": `pages-Bookings-styles___confirmationBodyTextStyle--LZbic`,
	"bolder": `pages-Bookings-styles___bolder--tAf4R`,
	"boldText": `pages-Bookings-styles___boldText--jKrHz`
};
module.exports = ___CSS_LOADER_EXPORT___;
